<template>
  <div>
    <b-breadcrumb style="background-color: #f8f9fa">
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{$t("dashboard")}}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="!isDirectAddApprovalLink"
        to="/employee-approvals"
      >
        {{$t("approvals.myApprovals")}}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{$t("approvals.newApproval")}}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-overlay
      :show="isLoading || isLoadingData"
      rounded="sm"
    >
      <b-container
        fluid
        class="m-0 text-center"
        v-if="!isLoading"
      >
        <b-row>
          <b-col
            cols="10"
            offset="1"
          >
            <div>
              <b-form-group
                class="mb-2"
                label-cols-sm="4"
                label-cols-lg="3"
                :label="$t('TypeofExpense') + ':'"
              >
                <v-select
                  class="style-chooser"
                  placeholder=""
                  :maxHeight="220"
                  :options="approvalTypesOptions"
                  v-model="selectForm.approvalType"
                  @input="onSelectOption($event)"
                  label="text"
                  track-by="value"
                ></v-select>
              </b-form-group>
            </div>
            <b-card v-if="formSchema != null && form != null">
              <EmployeeApprovalForm
                :form="form"
                :isLoading="isLoading"
                :isDisabled="isDisabled"
                :selectedLanguage="selectedLanguage"
              />
              <b-row class="mt-3">
                <b-col
                  cols="6"
                  class="text-left"
                >
                  <a
                    v-if="form.formSection.length"
                    href="#"
                    class="btn btn-warning"
                    v-scroll-to="{ el: '#scrollspy', container: '#scrollspy', duration: 300, easing: 'linear', force: true, x: false, y: true }"
                  >
                    <font-awesome-icon icon="angle-up" />
                  </a>
                </b-col>
                <b-col>
                  <div class="float-right">
                    <b-button
                      @click="onValidateSubmit"
                      variant="outline-success"
                    >{{$t('submitText')}}</b-button>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <!-- review modal -->
        <b-modal
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          id="modal-1"
          modal-header-close="No"
          :ok-title="$t('submitText')"
          :cancel-title="$t('cancelBtnText')"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          :title="$t('approvals.submitModalTitle')"
          @ok="onSubmit"
        >
          <p>{{ $t("approvalFormSubmitingMessage") }}</p>
          <p></p>
        </b-modal>

        <b-modal
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          id="modal-2"
          :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          modal-header-close="No"
          ok-only
          :ok-title="$t('closeBtnText')"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          :title="$t('questionnaires.formSubmittedModalTitle')"
          @ok="$router.replace((isDirectAddApprovalLink) ? '/dashboard' : '/employee-approvals')"
        >
          <p>{{ $t("formSubmittedMessage") }}</p>
          <p></p>
        </b-modal>

        <b-alert
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          v-model="showErrorToast"
          class="position-fixed fixed-top m-0 rounded-0"
          style="z-index: 2000"
          variant="danger"
          dismissible
          solid
        >{{ $t("formValidationMessage") }}</b-alert>

        <b-modal
          id="modal-leave"
          modal-header-close="No"
          :ok-title="$t('closeBtnText')"
          :cancel-title="$t('cancelBtnText')"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          :title="$t('toast.title')"
          @ok="leaveConfirm = true"
        >
          <p>{{ $t("formLeaveAlertMessage") }}</p>
          <p></p>
        </b-modal>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import config from "./../../configs/config";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import SectionContainer from "../../containers/SectionUserContainer";
import EmployeeApprovalForm from "./employeeApprovalForm";
// import AppLoader from "../../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import _ from "lodash";
import { Helper } from "@/helpers";
// import { parse } from 'vue-currency-input';
import uid from "uid";

export default {
  name: "employeeApprovalFormComponent",
  components: {
    EmployeeApprovalForm,
    SectionContainer,
    // AppLoader,
  },
  data () {
    return {
      isLoadingData: false,
      // form: null,
      selectForm: {
        approvalType: null,
        amount: null,
        approvalStatus: null
      },
      approvalTypesOptions: [],
      formSchema: null,
      isDisabled: 0,
      enabled: true,
      dragging: false,
      selected: "english",
      isInvalid: false,
      pageIntroText: "",
      showingIntro: true,
      showErrorToast: false,
      currentSectionIndex: 0,
      taskStatus: null,
      userConsent: 0,
      taskAssignedDate: null,
      taskCompletedDate: null,
      taskId: null,
      isDirectAddApprovalLink: false,
      taskFiles: [],
      fromButton: false,
      isLoadingLocal: false,
      groupId: null,
      // isLoading: false,
      inValidElements: [],
      inValidSections: [],
      leaveConfirm: false,
      initialResults: [],
      riskData: {
        percentage: null,
        risk: null,
        rating: null,
        color: null,
      },
      // progress bar
    };
  },

  mounted () {
    this.getApprovalTypesList();
  },
  created () {
    EventBus.$on( "onDirectAddApprovalLink", ( value ) => {
      this.isDirectAddApprovalLink = true;
    } );
  },
  beforeDestroy () { },

  beforeRouteLeave ( to, from, next ) {
    let employeeIdActive = localStorage.getItem( "employeeId" );
    if ( this.$route.name == "userform" ) {
      // console.log("leaving route..");
      if ( this.fromButton || this.$store.state.form1.isReadOnly == 1 || !employeeIdActive) {
        next();
      } else {
        // this.$bvModal.show("modal-leave");
        const answer = window.confirm( this.$t( "formLeaveAlertMessage" ) );
        if ( answer ) {
          // console.log("-------clear userFormSubmitArray--------- ");
          this.$store.state.userFormSubmitArray = [];
          this.$store.state.getUserFormSubmitArray = [];
          this.onResetLocalData();
          next();
        } else {
          next( false );
        }
      }
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),

    ...mapState( {
      userFormSubmitArray: "userFormSubmitArray",
      form: "form1",
      validFields: "validFields",
      rightAlign: "rightAlign",
      progressValue: "progressValue",
      progressMaxValue: "progressMaxValue",
    } ),
  },

  watch: {
    selectedLanguage ( lang ) {
      this.updateTitles( lang );
    },
  },

  methods: {
    ...mapActions( ["setLanguage"] ),
    ...mapMutations( ["TOGGLE_LOADER"] ),
    ...mapMutations( ["UPDATE_FORM"] ),

    async getApprovalTypesList () {
      this.approvalTypesOptions = [];
      this.isLoadingData = true;
      let formData = {
        language: localStorage.getItem( "formDefaultLanguage" ),
      };
      try {
        let result = await HTTP( "post", "api/v1/approvals/type/list", formData );
        this.approvalTypesOptions = result.data.approvalTypes;
        this.selectForm.approvalType = result.data.approvalTypes[0];
        this.form = null;
        this.selectForm.amount = null;
        this.getTaskForm( this.selectForm.approvalType );
        // this.isLoadingData = false;
      } catch ( error ) {
        this.isLoadingData = false;
      }
    },

    onSelectOption ( value ) {
      console.log( "value", value );
      let form1 = {
        version: 1.0,
        formId: null,
        formStatus: 1, // 1=draft, 2=published, 3=expired
        formDefaultLanguage: "english",
        formVersion: null,
        formTitle: {
          english: "Form Title",
        },
        formDescription: {
          english: "Form Description",
        },
        formIntroText: {
          english: null,
        },
        formType: 1, // 1= Questionaire, 2= Survey, 3=Training, 4= Exam
        formTranslations: ["English"],
        formSection: [
          {
            type: "section",
            id: uid(),
            index: 0,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: "Section 1 Title",
            },
            formElements: [],
          },
        ],
        formJSCode: null,
        formCSS: null,
        formLayout: "vertical", // 'tabs',
        formPassword: null,
      };
      this.$store.state.userFormSubmitArray = [];
      this.$store.state.getUserFormSubmitArray = [];
      this.UPDATE_FORM( form1 );
      this.form = null;
      this.selectForm.amount = null;
      this.selectForm.approvalStatus = null;
      this.isLoadingData = true;
      // this.form = null;
      this.selectForm.amount = null;
      this.getTaskForm( value );
    },
    async reOpenTask () {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        await HTTP(
          "post",
          "v1/mytpp/task/reopen/" + this.taskId,
          { taskStatus: 1 },
          {
            Authorization: token,
          },
          null,
          true
        );
        // this.$router.replace( "/my-questionnaires" );
      } catch {
        // console.log("------------erroror");
      }
    },

    makeToast () {
      const h = this.$createElement;
      const vNodesMsg = h( "p", { class: ["text-center", "mb-0"] }, [
        h( "b-spinner", { props: { type: "grow", small: true } } ),
        // " We are generating your PDF... ",
        this.$t( "toast.generatePDF" ),
        h( "b-spinner", { props: { type: "grow", small: true } } ),
      ] );
      this.$bvToast.toast( [vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000,
      } );
    },

    async downloadPdf ( taskId, route ) {
      let titleForm = localStorage.getItem( "task_title" ) + ".pdf";
      let formDefaultLanguage = localStorage.getItem( "formDefaultLanguage" );
      this.makeToast();
      axios( {
        url: config.API_URL + "v1/mytpp" + route + "/" + taskId,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
        data: { formDefaultLanguage: formDefaultLanguage },
      } )
        .then( ( response ) => {
          if ( window.navigator.msSaveOrOpenBlob ) {
            // let blob = response.data.blob;
            let blob = new Blob( [response.data] );
            // IE11
            window.navigator.msSaveOrOpenBlob( blob, titleForm );
            Helper.makeToast(
              this.$bvToast,
              "success",
              this.$t( "toast.successPDF" ),
              this.$t( "toast.title" )
            );
            return;
          } else {
            const url = window.URL.createObjectURL( new Blob( [response.data] ) );
            const link = document.createElement( "a" );
            link.href = url;
            link.setAttribute( "download", titleForm ); //or any other extension
            document.body.appendChild( link );
            link.click();
            if ( response ) {
              Helper.makeToast(
                this.$bvToast, "success",
                this.$t( "toast.successPDF" ),
                this.$t( "toast.title" )
              );
            }
          }
        } )
        .catch( ( error ) => {
          Helper.makeToast(
            this.$bvToast,
            "danger",
            this.$t( "toast.errorPDF" ),
            this.$t( "toast.title" )
          );
          return error;
        } );
    },

    onClickProceed () {
      this.setUserConsent();
      this.setUserFormSchemaToStore();
      //this.initializeFormData();
    },

    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
      localStorage.removeItem( "activeFormId" );
      localStorage.removeItem( "userConsent" );
      this.$store.state.registerData = {};
      this.$store.state.progressValue = 0;
      this.$store.state.progressMaxValue = 0;
    },

    async setUserConsent () {
      //let taskId = localStorage.getItem("taskId");
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        await HTTP(
          "post",
          "v1/mytpp/task/consent/" + this.taskId,
          { taskStatus: 1, userConsent: this.userConsent },
          {
            Authorization: token,
          },
          null,
          true
        );
      } catch {
        // console.log("------------erroror");
      }
      this.showingIntro = false;
    },

    initializeFormData () {
      // console.log("------initializeFormData---------- ");
      // let formDefaultLanguage = localStorage.getItem( "formDefaultLanguage" );
      let formDefaultLanguage = 'english';
      // this.$store.state.progressMaxValue = 0;
      if ( this.$store.state.getUserFormSubmitArray && this.$store.state.getUserFormSubmitArray.length ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
        // this.$store.state.progressMaxValue = this.$store.state.getUserFormSubmitArray.length;
        // this.calculateProgressValue( this.$store.state.getUserFormSubmitArray );
        // console.log("loading previously saved data....");
      } else {
        // console.log("loading new data....");
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep( this.form );
        tempForm.formSection.map( ( section ) => {
          section.formElements.map( ( element, elementIndex ) => {
            // this.$store.state.progressMaxValue += 1;
            this.$store.state.userFormSubmitArray.push( {
              elements: [],
              sectionId: section.id,
              sectionIndex: section.index,
              elementIndex: elementIndex,
              elementId: element.id,
              elementInputType: element.inputType,
              // elementTitle: element.label[this.selectedLanguage],
              // sectionTitle: section.sectionTitle[this.selectedLanguage]
              elementTitle: element.label,
              elementTitleAbb: element.abbreviationLabelText || element.label,
              question_abb_table: element.labelForTable || null,
              sectionTitle: section.sectionTitle,
              language: formDefaultLanguage,
              isMultiSelect: element.configuration ? element.configuration.isMultipleSelect ? 1 : 0 : 0,
              weightage: element.weightage || null,
              dataAttributes: element.dataAttributes || null,
              selectedChart: element.selectedCharts || null,
              isWorkFlowNa: element.isNa && element.isNa == 1 ? 1 : 0,
              isHyperLink: element.isHyperLink ? 1 : 0,
              hyperLinkUrl: element.hyperLinkUrl || null,
              hyperLinkText: element.hyperLinkText || null,
              hyperLinkTextBefore: element.hyperLinkTextBefore || null,
              hyperLinkTextAfter: element.hyperLinkTextAfter || null,
              isHiddenElement: element.isHidden && element.isHidden ? 1 : 0,
              isHiddenSection: section.isHidden && section.isHidden ? 1 : 0,
              enableFilterForManageThirdParty: ( element && parseInt( element.enableFilterForManageThirdParty ) ) || 0,
              enableSelfReportingForManageThirdParty: ( element && parseInt( element.enableSelfReportingForManageThirdParty ) ) || 0,
              enableSelfReportingForThirdPartyProfile: ( element && parseInt( element.enableSelfReportingForThirdPartyProfile ) ) || 0,
            } );
          } );
        } );
        // location.reload();
      }

      // EventBus.$emit("onUpdateValues", "form submit");
      // this.getSavedData();
    },

    updateTitles ( lang ) {
      // console.log("lang", lang);
      const dd = this.$store.state.userFormSubmitArray;
      dd.map( ( a ) => {
        // let returnValue = { ...a };
        return ( a.language = lang );
        // return returnValue;
      } );
    },

    calculateProgressValue ( array ) {
      const registerData = _.clone( this.$store.state.registerData );
      for ( let i = 0; i < array.length; i++ ) {
        // this.$store.state.progressValue += array[i].elements.length
        // // console.log("asasas", array[i].elements[0]);

        if (
          array[i] &&
          array[i].elements &&
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.length
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        } else {
          // delete registerData[array[i].elementId];
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].length &&
          array[i].elements[0][0].postValue
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }
        if (
          array[i].elements.length > 0 &&
          array[i].elements[0].postValue &&
          array[i].elements[0].postValue.phone
        ) {
          registerData[array[i].elementId] = array[i].elementId;
        }

        // else {
        //   delete registerData[array[i].elementId];
        // }
        // main calculations :p
      }
      // // console.log("asasas", registerData);
      this.$store.state.registerData = registerData;
      let numkeys = Object.keys( registerData ).length;
      this.$store.state.progressValue = numkeys;
    },

    changeLanguage () {
      let tt = this.selected.toLowerCase();
      this.setLanguage( tt );
      this.TOGGLE_LOADER( 100 );
    },

    setUserFormSchemaToStore () {
      let form = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
      // let taskdata = JSON.parse(localStorage.getItem("taskFormData"));
      this.updateFormToStore( form );
    },

    updateFormToStore ( form ) {
      this.UPDATE_FORM( form );
      // this.reloadTable();
    },

    onValidateSubmit () {
      EventBus.$emit( "onSubmitEndUserForm", "form submit" );
      this.selectForm.amount = null;
      this.selectForm.approvalStatus = null;
      this.getInvalidFields();
      this.checkForInValidFields();
    },

    setFieldsValue () {
      let selectedAmount = null;
      let amountFieldsIndex = this.$store.state.userFormSubmitArray.findIndex(
        ( x ) => x.elementTitle.english.includes( 'Amount in USD' )
      );
      if ( this.$store.state.userFormSubmitArray[amountFieldsIndex] && this.$store.state.userFormSubmitArray[amountFieldsIndex].elements && this.$store.state.userFormSubmitArray[amountFieldsIndex].elements[0] && this.$store.state.userFormSubmitArray[amountFieldsIndex].elements[0].postValue ) {
        selectedAmount = this.$store.state.userFormSubmitArray[amountFieldsIndex].elements[0].postValue;
      }
      this.selectForm.amount = selectedAmount ? parseInt( selectedAmount ) : null;
      if ( this.selectForm.amount ) {
        let selectedDataAttributes = this.$store.state.userFormSubmitArray[amountFieldsIndex].dataAttributes ? this.$store.state.userFormSubmitArray[amountFieldsIndex].dataAttributes : [];
        if ( selectedDataAttributes && selectedDataAttributes != undefined && selectedDataAttributes.length != 0 ) {
          let minAmountIndexAttribute = selectedDataAttributes.findIndex(
            ( x ) => x.dataAttributeKey == "min_amount"
          )
          let minAmount = selectedDataAttributes[minAmountIndexAttribute].dataAttributeValue ? selectedDataAttributes[minAmountIndexAttribute].dataAttributeValue : null;

          let maxAmountIndexAttribute = selectedDataAttributes.findIndex(
            ( x ) => x.dataAttributeKey == "max_amount"
          )
          let maxAmount = selectedDataAttributes[maxAmountIndexAttribute].dataAttributeValue ? selectedDataAttributes[maxAmountIndexAttribute].dataAttributeValue : null;

          let approvalStatusIndexAttribute = selectedDataAttributes.findIndex(
            ( x ) => x.dataAttributeKey == "approval_status"
          )
          let approvalStatus = selectedDataAttributes[approvalStatusIndexAttribute].dataAttributeValue ? selectedDataAttributes[approvalStatusIndexAttribute].dataAttributeValue : null;

          if ( maxAmount || minAmount || approvalStatus ) {
            this.checkAmountField( minAmount, maxAmount, approvalStatus );
            return;
          }
        }
      }
      this.checkFieldsConditions();
    },
    checkFieldsConditions () {
      this.$store.state.userFormSubmitArray.forEach( formData => {
        if ( !this.selectForm.approvalStatus ) {
          if ( formData && formData.elements && formData.elements[0] && formData.elements[0].custom_values && formData.elements[0].custom_values[0] ) {
            let approvalStatus = formData.elements[0].custom_values[0].approval_status ? formData.elements[0].custom_values[0].approval_status : null;
            let minAmount = formData.elements[0].custom_values[0].min_amount ? formData.elements[0].custom_values[0].min_amount : null;
            let maxAmount = formData.elements[0].custom_values[0].max_amount ? formData.elements[0].custom_values[0].max_amount : null;
            this.checkAmountField( minAmount, maxAmount, approvalStatus );
          }
        }
      } );
      if ( !this.selectForm.approvalStatus ) {
        this.selectForm.approvalStatus = 1;
        this.onReviewSubmit();
      }
    },

    checkAmountField ( minAmount, maxAmount, approvalStatus ) {
      if ( minAmount && minAmount.length == 0 ) {
        minAmount = null;
      }
      if ( maxAmount && maxAmount.length == 0 ) {
        maxAmount = null;
      }
      if ( approvalStatus && approvalStatus.length == 0 ) {
        approvalStatus = null;
      }
      let intMinAmount = minAmount ? parseInt( minAmount ) : null;
      let intMaxAmount = maxAmount ? parseInt( maxAmount ) : null;

      if ( !maxAmount && !minAmount && approvalStatus ) {
        this.selectForm.approvalStatus = approvalStatus;
        this.onReviewSubmit();
      } else if ( maxAmount && minAmount && approvalStatus ) {
        if ( intMinAmount <= this.selectForm.amount && this.selectForm.amount <= intMaxAmount ) {
          this.selectForm.approvalStatus = approvalStatus;
          this.onReviewSubmit();
        } else {
          this.selectForm.approvalStatus = 1;
          this.onReviewSubmit();
        }
      }
    },

    checkForInValidFields () {
      let isValid = false;
      outerLoop: for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for ( let x = 0; x < this.$store.state.form1.formSection[i].formElements.length; x++ ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            let inValidData = {
              elementId: this.$store.state.form1.formSection[i].formElements[x].id,
              sectionId: this.$store.state.form1.formSection[i].id,
            };
            EventBus.$emit( "OnInvalidFieldCatch", inValidData );
            this.showErrorToast = true;
            isValid = false;
            // console.log( "inValidElements", this.inValidElements );
            break outerLoop;
          }
          isValid = true;
        }
      }
      if ( isValid ) {
        this.setFieldsValue();
      }
    },

    getInvalidFields () {
      this.inValidElements = [];
      this.inValidSections = [];
      for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for ( let x = 0; x < this.$store.state.form1.formSection[i].formElements.length; x++ ) {
          if ( this.$store.state.form1.formSection[i].formElements[x].isInValid ) {
            this.inValidElements.push( this.$store.state.form1.formSection[i].formElements[x] );
          }
        }
      }
    },

    onReviewSubmit () {
      if ( this.$store.state.validFields ) {
        let userDetails = JSON.parse( localStorage.getItem( "userDetail" ) );
        this.showErrorToast = false;
        let formData = {
          approval_type_id: this.selectForm.approvalType ? this.selectForm.approvalType.value : null,
          approval_type: this.selectForm.approvalType ? ( this.selectForm.approvalType.title ? ( this.selectForm.approvalType.title[this.selectedLanguage] ? this.selectForm.approvalType.title[this.selectedLanguage] : null ) : null ) : null,
          approval_type_english: this.selectForm.approvalType ? ( this.selectForm.approvalType.title ? ( this.selectForm.approvalType.title['english'] ? this.selectForm.approvalType.title['english'] : null ) : null ) : null,
          currency_id: 1,
          employee_id: localStorage.getItem( "employeeId" ),
          amount: this.selectForm.amount,
          form_data: this.$store.state.userFormSubmitArray,
          form_id: localStorage.getItem( 'activeFormId' ),
          language_id: userDetails.employee_language_id,
          form_version_id: localStorage.getItem( 'activeFormVersionsId' ),
          status: this.selectForm.approvalStatus,
          user_id: localStorage.getItem( "userId" ),
        };
        // console.log( "formData", this.selectForm.approvalType );
        console.log( "approval status", this.selectForm.approvalType );
        // this.makeToster( "status", this.selectForm.approvalStatus);
        this.$bvModal.show( "modal-1" );
      } else {
        this.showErrorToast = true;
      }
    },

    async onSubmit () {
      this.saveApproval();
    },
    makeToster ( tosterVarient, tosterMsg ) {
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },

    async saveApproval () {
      // let employeeId = localStorage.getItem( "employeeId" );
      let filesCount = 0;
      let form_data = this.$store.state.userFormSubmitArray;
      form_data.map( ( elementsData ) => {
        if (
          elementsData.elementInputType == "file"
        ) {
          filesCount = ( elementsData.elements ) ? ( ( elementsData.elements.length > 0 ) ? ( ( elementsData.elements[0] ) ? ( ( elementsData.elements[0].postValue ) ? ( elementsData.elements[0].postValue.length > 0 ? elementsData.elements[0].postValue.length : 0 ) : 0 ) : 0 ) : 0 ) : 0;
        }
      } );

      let userDetails = JSON.parse( localStorage.getItem( "userDetail" ) );
      this.isLoadingData = true;
      let formData = {
        approval_type_id: this.selectForm.approvalType ? this.selectForm.approvalType.value : null,
        approval_type: this.selectForm.approvalType ? ( this.selectForm.approvalType.title ? ( this.selectForm.approvalType.title[this.selectedLanguage] ? this.selectForm.approvalType.title[this.selectedLanguage] : null ) : null ) : null,
        approval_type_english: this.selectForm.approvalType ? ( this.selectForm.approvalType.title ? ( this.selectForm.approvalType.title['english'] ? this.selectForm.approvalType.title['english'] : null ) : null ) : null,
        currency_id: 1,
        meta_data: { filesCount: filesCount },
        employee_id: localStorage.getItem( "employeeId" ),
        amount: this.selectForm.amount,
        form_data: this.$store.state.userFormSubmitArray,
        form_id: localStorage.getItem( 'activeFormId' ),
        language_id: userDetails.employee_language_id,
        form_version_id: localStorage.getItem( 'activeFormVersionsId' ),
        status: this.selectForm.approvalStatus,
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        let result = await HTTP( "post", "api/v1/approvals/create", formData );
        this.submiting = false;
        this.responseSuccess = true;
        if ( result.data.status != 1 ) {
          this.makeToster( "danger", result.data.message );
        } else if ( result.data.status == 1 ) {
          // this.makeToster( "success", result.data.message );
          this.fromButton = true;
          this.$bvModal.show( "modal-2" );
          // let url = (this.isDirectAddApprovalLink) ? '/dashboard' : '/employee-approvals';
          // this.$router.replace(url);
        }
        this.isLoadingData = false;
      } catch ( err ) {
        this.submiting = false;
        this.isLoadingData = false;
        this.responseSuccess = false;
        return [err];
      }
    },

    checkExistanceCountry () {
      let sections = this.$store.state.form1.formSection;
      let sec4score = null;

      let compareSectionSix = sections.find(
        ( sec ) =>
          sec.sectionTitle[this.selectedLanguage] == "Details of Services/Goods"
      );
      let sectionFour = sections.find(
        ( sec ) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );
      let foundSectionFourEle = this.$store.state.userFormSubmitArray.find(
        ( ele ) => ele.elementId == sectionFour.formElements[0].id
      );

      if ( compareSectionSix ) {
        let found = compareSectionSix.formElements.find(
          ( a ) => a.inputType == "countries"
        );

        if ( found ) {
          let foundSectionSixEle = this.$store.state.userFormSubmitArray.find(
            ( ele1 ) => ele1.elementId == found.id
          );

          if ( foundSectionFourEle ) {
            sec4score = foundSectionFourEle.elements.find( ( ele ) => ele );
          }



          if ( foundSectionSixEle && foundSectionSixEle.elements.length ) {

            foundSectionSixEle.elements.find( ( ele ) => {
              if ( ( foundSectionFourEle.isHiddenElement == 0 && ele.score == 13 && sec4score ) ) {
                ele.score = 0;
                sec4score.score = 13;
              } else if ( foundSectionFourEle.isHiddenElement == 0 && ele.score && sec4score && sec4score.score == 0 ) {
                sec4score.score = 0

              } else {
                ele.score = 0;
              }
            } );
          } else {
            sec4score.score = sec4score.postValue[0].riskScore
          }

          let highestScore = found.dataAttributes.find(
            ( atr ) => atr.dataAttributeKey == "highest_score"
          );
          highestScore.dataAttributeValue = 0;
        }
      }
    },

    calculateHighestScoreForCategory () {
      let topics = [];
      this.checkExistanceCountry();

      this.$store.state.form1.formSection.map( ( section ) => {
        section.formElements.map( ( element ) => {

          if ( element.dataAttributes ) {
            let topic = element.dataAttributes.find(
              ( ele ) => ele.dataAttributeKey == "topic"
            );
            let highestScore = element.dataAttributes.find(
              ( ele ) => ele.dataAttributeKey == "highest_score"
            );

            if ( highestScore && highestScore.dataAttributeValue != 0 ) {
              let hh = parseFloat( highestScore.dataAttributeValue ) || 0;
              // let ss = (foundScore.score && parseFloat(foundScore.score)) || 0;

              topics.push( {
                topic: ( topic && topic.dataAttributeValue ) || null,
                weightage: parseFloat( element.weightage ),
                actualScore: 0,
                highestScore1: hh,
              } );
            }
          }
        } );
      } );


      const newTopicsArr = [];
      const newTopicsIdArr = [];
      for ( const topic of topics ) {
        const index = newTopicsIdArr.indexOf( topic.topic );
        if ( index >= 0 ) {
          newTopicsArr[index].actualScore += topic.actualScore;
          newTopicsArr[index].highestScore1 += topic.highestScore1;
        } else {
          newTopicsIdArr.push( topic.topic );
          newTopicsArr.push( topic );
        }
      }
      this.calculateRiskScore( newTopicsArr );
    },

    calculateRiskScore ( highestScoress ) {
      this.initialResults = [];
      let topics = [],
        initialResults = [];
      this.$store.state.userFormSubmitArray.map( ( element ) => {
        if ( element.dataAttributes ) {
          let foundScore = element.elements.find( ( ele ) => ele );
          let topic = element.dataAttributes.find(
            ( ele ) => ele.dataAttributeKey == "topic"
          );
          let highestScore = element.dataAttributes.find(
            ( ele ) => ele.dataAttributeKey == "highest_score"
          );


          if (
            foundScore &&
            highestScore &&
            highestScore.dataAttributeValue != 0
          ) {
            let hh = parseFloat( highestScore.dataAttributeValue ) || 0;
            let ss = ( foundScore.score && parseFloat( foundScore.score ) ) || 0;

            topics.push( {
              topic: ( topic && topic.dataAttributeValue ) || null,
              weightage: parseInt( element.weightage ),
              actualScore: ss,
              highestScore1: hh,
            } );
          }
        }
      } );
      const newTopicsArr = [];
      const newTopicsIdArr = [];
      for ( const topic of topics ) {
        const index = newTopicsIdArr.indexOf( topic.topic );
        if ( index >= 0 ) {
          newTopicsArr[index].actualScore += topic.actualScore;
          // newTopicsArr[index].highestScore1 = tt.highestScore1;
        } else {
          newTopicsIdArr.push( topic.topic );
          newTopicsArr.push( topic );
        }
      }

      newTopicsArr.map( ( a ) => {
        let y = highestScoress.find( ( t ) => t.topic == a.topic );
        return ( a.highestScore1 = y.highestScore1 );
      } );
      initialResults = newTopicsArr.map( ( ele ) => {
        let finalScoreForTopic =
          ( ele.actualScore / ele.highestScore1 ) * ele.weightage;
        this.analyseTopicRiskData(
          ele.actualScore,
          ele.topic,
          finalScoreForTopic
        );
        return {
          ...ele,
          finalScoreForTopic,
          data: this.riskData,
        };
      } );

      // initialResults = initialResults.map((ele) => {
      //   this.analyseRiskData(ele.finalScoreForTopic);
      // });

      this.initialResults = initialResults;
      let sum = initialResults.reduce(
        ( accum, item ) => accum + item.finalScoreForTopic,
        0
      );

      // console.log("sum", sum);
      // sum = 88;
      this.analyseRiskData( sum );
    },

    analyseRiskData ( sum ) {
      switch ( true ) {
        case sum >= 0 && sum < 5:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score : 1");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "1",
          };
          break;
        case sum >= 5 && sum < 15:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score: 2");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "2",
          };
          break;

        case sum >= 15 && sum < 25:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score: 3");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "3",
          };
          break;

        case sum >= 25 && sum < 35:
          // console.log("%", sum);
          // console.log("Risk : Low");
          // console.log("color : Green");
          // console.log("Score: 4");
          this.riskData = {
            percentage: sum,
            risk: "Low",
            color: "Green",
            rating: "4",
          };
          break;

        case sum >= 35 && sum < 45:
          // console.log("%", sum);
          // console.log("Risk : Moderate");
          // console.log("color : Yellow");
          // console.log("Score: 5");
          this.riskData = {
            percentage: sum,
            risk: "Moderate",
            color: "Yellow",
            rating: "5",
          };
          break;
        case sum >= 45 && sum < 55:
          // console.log("%", sum);
          // console.log("Risk : Moderate");
          // console.log("color : Yellow");
          // console.log("Score: 6");
          this.riskData = {
            percentage: sum,
            risk: "Moderate",
            color: "Yellow",
            rating: "6",
          };
          break;
        case sum >= 55 && sum < 65:
          // console.log("%", sum);
          // console.log("Risk : Moderate");
          // console.log("color : Yellow");
          // console.log("Score: 7");
          this.riskData = {
            percentage: sum,
            risk: "Moderate",
            color: "Yellow",
            rating: "7",
          };
          break;
        case sum >= 65 && sum < 75:
          // console.log("%", sum);
          // console.log("Risk : High");
          // console.log("color : Red");
          // console.log("Score: 8");
          this.riskData = {
            percentage: sum,
            risk: "High",
            color: "Red",
            rating: "8",
          };
          break;
        case sum >= 75 && sum < 85:
          // console.log("%", sum);
          // console.log("Risk : High");
          // console.log("color : Red");
          // console.log("Score: 9");
          this.riskData = {
            percentage: sum,
            risk: "High",
            color: "Red",
            rating: "9",
          };
          break;
        case sum >= 85 && sum <= 100:
          // console.log("%", sum);
          // console.log("Risk : High");
          // console.log("color : Red");
          // console.log("Score: 10");
          this.riskData = {
            percentage: sum,
            risk: "High",
            color: "Red",
            rating: "10",
          };
          break;

        default:
          // console.log("%", sum);
          // console.log("Risk : Invalid");
          // console.log("color : Invalid");
          // console.log("Score: Invalid");
          this.riskData = {
            percentage: sum,
            risk: "Invalid",
            rating: "Invalid",
            color: "Invalid",
          };
      }
    },

    analyseTopicRiskData ( sum, topic, percentage ) {
      switch ( topic ) {
        case "jurisdiction":
          {
            if ( sum > 12 && sum <= 18 ) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if ( sum > 4 && sum <= 12 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if ( sum >= 0 && sum <= 4 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "activity":
          {
            if ( sum > 15 && sum <= 32 ) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if ( sum > 5 && sum <= 15 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if ( sum >= 0 && sum <= 5 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "workforce":
          {
            if ( sum > 14 ) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if ( sum >= 0 && sum <= 14 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "policies_and_systems":
          {
            if ( sum > 10 && sum <= 13 ) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if ( sum > 6 && sum <= 10 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if ( sum >= 0 && sum <= 6 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
        case "human_rights":
          {
            if ( sum > 10 && sum <= 13 ) {
              this.riskData = {
                percentage: percentage,
                risk: "High",
                color: "Red",
                score: sum,
              };
            } else if ( sum > 4 && sum <= 10 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Moderate",
                color: "Yellow",
                score: sum,
              };
            } else if ( sum >= 0 && sum <= 4 ) {
              this.riskData = {
                percentage: percentage,
                risk: "Low",
                color: "Green",
                score: sum,
              };
            } else {
              this.riskData = {
                percentage: percentage,
                risk: "Invalid",
                color: "Invalid",
                score: sum,
              };
            }
          }
          break;
      }
    },

    async saveFormData ( status ) {
      let userId = localStorage.getItem( "userId" );
      let taskId = localStorage.getItem( "taskId" );
      let formDefaultLanguage = localStorage.getItem( "formDefaultLanguage" );
      // // console.log("this.$store.state.userFormSubmitArray", this.$store.state.userFormSubmitArray)
      let taskData = this.$store.state.userFormSubmitArray;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/submitform",
          {
            userId: userId,
            taskData: taskData,
            status: status,
            taskId: taskId,
            riskData: {
              ...this.riskData,
              data: this.initialResults,
            },
            formDefaultLanguage: formDefaultLanguage,
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        if ( result ) {
          this.fromButton = true;
          this.$bvModal.show( "modal-2" );
        }
      } catch {
        this.fromButton = true;
        this.$bvModal.show( "modal-2" );
        // console.log("------------erroror");
      }
    },

    onScrollClick ( index ) {
      // console.log("index", index);
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById( id ).scrollIntoView( { behavior: "smooth" } );
    },

    // auto save logic for user form--------
    async onSavePostData () {
      EventBus.$emit( "onSubmitEndUserForm", "progress" );
      // console.clear();
      this.isLoadingLocal = true;
      // console.log("saving data...-----");
      // let aa = _.isEqual(this.$store.state.userFormSubmitArray, this.$store.state.getUserFormSubmitArray)
      // // console.log("userFormSubmitArray...", this.$store.state.userFormSubmitArray);

      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let taskData = this.$store.state.userFormSubmitArray;
      try {
        await HTTP(
          "post",
          "v1/mytpp/task/save/" + this.taskId,
          { taskData: taskData },
          {
            Authorization: token,
          },
          null,
          false
        );
        this.isLoadingLocal = false;
        Helper.makeToast(
          this.$bvToast,
          "success",
          this.$t( "toast.saveSuccess" ),
          this.$t( "toast.title" )
        );
      } catch {
        this.isLoadingLocal = false;
        Helper.makeToast( this.$bvToast, "danger", this.$t( "toast.saveError" ) );
        // console.log("------------erroror");
      }
    },

    checkForNewUser ( data ) {
      // let array = this.$store.state.getUserFormSubmitArray;
      // console.log("checkForNewUser", this.$store.state.getUserFormSubmitArray);
      let array = data;
      let aa = array.find( ( ele ) => ele.elements );
      // console.log("aa", aa)
      if ( aa ) {
        return true;
      } else {
        return null;
      }
    },
    async getTaskForm ( approval ) {
      this.$store.state.userFormSubmitArray = [];
      this.isLoadingData = true;
      let formData = {
        approval_type_id: approval.onboarding_forms_id,
        approval: approval.text,
        employee_id: localStorage.getItem( "employeeId" )
      };
      try {
        let result = await HTTP( "post", "api/v1/approvals/type/schema", formData, null, null, true );
        if ( result.data.task ) {
          let form = result.data.task.schema;
          this.$store.state.getUserFormSubmitArray = [];
          localStorage.setItem( "activeFormSchema", form );
          localStorage.setItem( "activeFormId", result.data.task.id );
          localStorage.setItem( "activeFormVersionsId", result.data.task.onboarding_form_versions_id );
          this.setUserFormSchemaToStore();
          this.initializeFormData();
          let ff = JSON.parse( form );
          this.formSchema = ff;
          // this.taskStatus = result.data.task.task_status;
          this.taskStatus = 4;
          this.isDisabled = 0;
          if ( ff.isShowFormIntro ) {
            this.pageIntroText = ff.formIntroText[this.selectedLanguage];
          }

        }
        console.clear();
        this.isLoadingData = false;
      }
      catch ( error ) {
        this.isLoadingData = false;
        return error;
      }
    },
  },
};
</script>
<style scoped>
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(calc(100vh - 367px));
  /* height:400px */
}
.selectPicket {
  width: 350px;
}
</style>
<style>
/* .v-select .vs__dropdown-menu {
  height: 230px;
} */
.style-chooser .vs__dropdown-menu {
  height: 230px !important;
}
</style>
